import React from 'react';
import { bool, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../../util/reactIntl';
import * as validators from '../../../../util/validators';

import { Form, FieldPhoneInput, Button } from '../../../../components';

import css from './ElephantVerificationForm.module.css';
import { checkElepantResponseSubmited } from '../../../../util/data';

const ElephantVerificationFormFields = props => {
  const {
    className,
    formId,
    handleSubmit,
    inProgress,
    invalid,
    intl,
    values,
    currentUser,
    onSetElephantVerificationModal,
  } = props;

  const classes = classNames(className);
  const submitInProgress = inProgress;
  const submitDisabled = invalid || submitInProgress;

  const phoneFormatValid = validators.phoneFormatValid(
    intl.formatMessage({
      id: 'ElephantVerificationForm.vaildPhoneNumber',
    })
  );

  const isCheckElepantResponseSubmited = checkElepantResponseSubmited(currentUser);
  const hasPhoneNumber = !!(values?.phoneNumber && values.phoneNumber.trim());
  const submitDisabledFinal = submitDisabled || !hasPhoneNumber;

  return (
    <Form
      className={classes}
      onSubmit={e => {
        if (!hasPhoneNumber) {
          e.preventDefault();
          return;
        }
        handleSubmit(e);
      }}
    >
      {isCheckElepantResponseSubmited ? (
        <>
          <div className={css.platformaccess}>
            <FormattedMessage id="ElephantVerificationForm.elephantVerificationModalHead" />
            <div className={css.spacer}></div>
          </div>
          <div className={css.platformRestrictedUserHead}>
            <FormattedMessage id="ElephantVerificationForm.elephantVerificationModalHeadSub" />
          </div>
          <Button
            className={css.verifyButton}
            type="button"
            onClick={e => {
              e.preventDefault();
              onSetElephantVerificationModal(false);
            }}
          >
            <FormattedMessage id="ElephantVerificationForm.continueButton" />
          </Button>
        </>
      ) : (
        <>
          <div className={css.platformaccessLeft}>
            <FormattedMessage id="ElephantVerificationForm.elephantVerificationModalHead" />
          </div>
          <div className={css.platformRestrictedUserHeadLeft}>
            <FormattedMessage id="ElephantVerificationForm.elephantVerificationModalSubHead" />
          </div>

          <FieldPhoneInput
            className={css.phone}
            name="phoneNumber"
            id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
            label={intl.formatMessage({ id: 'ElephantVerificationForm.phoneLabel' })}
            placeholder={intl.formatMessage({
              id: 'ElephantVerificationForm.phonePlaceholder',
            })}
            validate={validators.composeValidators(
              validators.required(
                intl.formatMessage({
                  id: 'ElephantVerificationForm.phoneRequired',
                })
              ),
              phoneFormatValid
            )}
          />

          <Button
            className={css.verifyButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabledFinal}
          >
            <FormattedMessage id="ElephantVerificationForm.submitButton" />
          </Button>
          <div className={css.takesometimeText}>
            <FormattedMessage id="ElephantVerificationForm.verificationMaytakesometime" />
          </div>
        </>
      )}
    </Form>
  );
};

const ElephantVerificationFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => (
      <ElephantVerificationFormFields
        {...formRenderProps}
        currentUser={props.currentUser}
        onSetElephantVerificationModal={props.onSetElephantVerificationModal}
      />
    )}
  />
);

ElephantVerificationFormComponent.defaultProps = {
  formId: null,
  inProgress: false,
};

ElephantVerificationFormComponent.propTypes = {
  formId: string,
  inProgress: bool,
  // from injectIntl
  intl: intlShape.isRequired,
};

const ElephantVerificationForm = compose(injectIntl)(ElephantVerificationFormComponent);
ElephantVerificationForm.displayName = 'ElephantVerificationForm';

export default ElephantVerificationForm;
